import React from "react";
import { createUseStyles } from "react-jss";
import { useHistory } from "react-router-dom";
import ButtonLink from "./ButtonLink";

const useStyles = createUseStyles(theme => ({
  container: {
    flex: 0,
    padding: `${theme.spacing2} ${theme.spacing3}`,
    display: "flex",
    "background-color": theme.colorBackground,
    color: theme.textColor,
    "justify-content": "space-between",
    "border-bottom": `1px solid ${theme.colorDarkGrey}`,
  },
  actions: {
    display: "flex",
    margin: `0 -${theme.spacing3}`,
  },
  action: {
    margin: `0 ${theme.spacing3}`,
  },
  row: {
    display: "flex",
    alignItems: "center",
  },
  actionSlider: {
    "&::-webkit-slider-thumb": {
      "-webkit-appearance": "none",
      appearance: "none",
      width: 15,
      height: 15,
      "border-radius": "100%",
      background: "white",
      border: "1px solid gainsboro",
      cursor: "pointer",
    },
    "&::-moz-range-thumb": {
      "-webkit-appearance": "none",
      appearance: "none",
      width: 15,
      height: 15,
      "border-radius": "100%",
      background: "white",
      border: "1px solid gainsboro",
      cursor: "pointer",
    },
    "-webkit-appearance": "none",
    appearance: "none",
    height: 8,
    outline: "none",
    "border-radius": 6,
    background: "#403e3e",
    "box-shadow": "inset 0px -1px 2px #787171",
  },
}));

const Toolbar = ({
  renderLeft,
  renderRight,
  hideRightActions,
  onSaveTour,
  onEmbedTour,
  onTourSettings,
}) => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <div className={classes.container}>
      <div className={classes.actions}>
        {renderLeft !== undefined && renderLeft({ actionClasses: classes })}
      </div>
      <div className={classes.actions}>
        {renderRight !== undefined && renderRight({ actionClasses: classes })}
        {/*<ButtonLink
          className={classes.action}
          name="Preview Tour"
        />*/}
        {hideRightActions !== true && (
          <>
            <ButtonLink
              className={classes.action}
              name="Tour Options"
              onClick={onTourSettings}
            />
            <ButtonLink
              className={classes.action}
              name="Embed Tour"
              onClick={onEmbedTour}
            />
            <ButtonLink
              className={classes.action}
              name="Save Tour"
              onClick={onSaveTour}
            />
            <ButtonLink
              className={classes.action}
              onClick={() => {
                if (window.confirm("Are you sure you want to exit?")) {
                  history.push("/");
                }
              }}
              name="Exit"
            />
          </>
        )}
      </div>
    </div>
  );
};

export default Toolbar;
